import type { FC, ComponentProps } from 'react';
import { CartItems as BaseCartItems } from '../cart-items/cart-items';
import { CartItemGroupVariantEnum, CartItemV2VariantEnum } from '@kidslabs/mario-nextjs-react-ui-core';

export const MiniCartItemsRenderer: FC<ComponentProps<typeof BaseCartItems>> = props => {
    return (
        <BaseCartItems
            {...props}
            variantCartItemGroup={CartItemGroupVariantEnum.MINI}
            variantCartItemV2={CartItemV2VariantEnum.SMALL}
            isSwipeable={false}
            counterButton
        />
    );
};
